"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.columnStyle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _Error = _interopRequireDefault(require("../Error"));

var _row = _interopRequireDefault(require("./row"));

var _tableSelection = _interopRequireDefault(require("./tableSelection"));

var _tableHeader = _interopRequireDefault(require("./tableHeader"));

var _config = require("../config/config");

var _toIds = require("../_utils/toIds");

require("./table.sass");

var columnStyle = function columnStyle(_ref) {
  var width = _ref.width,
      maxWidth = _ref.maxWidth;
  return {
    width: width || 100,
    maxWidth: maxWidth
  };
};

exports.columnStyle = columnStyle;

var Table =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Table, _Component);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "height", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "element", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateHeight", function () {
      if (_this.element) {
        _this.height = _this.element.offsetHeight;

        _this.handleScroll();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleRef", function (element) {
      _this.element = element;

      _this.updateHeight();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getLowestSelectedIndex", function () {
      var _this$props = _this.props,
          selection = _this$props.selection,
          rows = _this$props.rows;
      var selectedIndexes = rows.filter(function (row) {
        return selection.has(row.id);
      }).map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      var maxId = Math.max.apply(Math, (0, _toConsumableArray2.default)(selectedIndexes));
      return maxId;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "massOperation", function (row) {
      var _this$props2 = _this.props,
          select = _this$props2.select,
          selection = _this$props2.selection,
          rows = _this$props2.rows;

      if (selection.isEmpty()) {
        select(row);
        return;
      }

      var indexTo = (0, _findIndex.default)(rows, {
        id: row.id
      });
      var lastSelectedIndex = (0, _findIndex.default)(rows, {
        id: selection.last
      });
      var correctSlice = lastSelectedIndex <= indexTo ? rows.slice(lastSelectedIndex, indexTo + 1) : rows.slice(indexTo, lastSelectedIndex + 1);
      select(correctSlice);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "isRowDisabled", function (id) {
      var disabledRowsIds = _this.props.disabledRowsIds;

      if (!disabledRowsIds) {
        return false;
      }

      return disabledRowsIds.includes(id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderRow", function (row, index) {
      var id = (0, _toIds.toId)(row);

      if (!_this.isRowVisible(index)) {
        return _react.default.createElement("div", {
          className: "table-row",
          key: id ? id : '#' + index
        });
      }

      var _this$props3 = _this.props,
          selection = _this$props3.selection,
          hasSelection = _this$props3.hasSelection,
          select = _this$props3.select,
          deselect = _this$props3.deselect,
          columns = _this$props3.columns,
          onRowClick = _this$props3.onRowClick,
          active = _this$props3.active,
          rowClassName = _this$props3.rowClassName,
          disabled = _this$props3.disabled,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["selection", "hasSelection", "select", "deselect", "columns", "onRowClick", "active", "rowClassName", "disabled"]);
      delete rest.className;
      delete rest.fullHeight;
      delete rest.rowHeight;
      delete rest.rows;
      delete rest.row;
      delete rest.selectionBar;
      var isFull = selection && selection.isFull();
      var isSelectedRow = selection && !selection.has(row);

      var isCheckboxDisabled = hasSelection && isFull && isSelectedRow || _this.isRowDisabled(row.id);

      return _react.default.createElement(_row.default, (0, _extends2.default)({
        key: id ? id : '#' + index,
        index: index,
        row: row,
        rowClass: rowClassName,
        columns: columns,
        onClick: onRowClick,
        active: active ? active.id === row.id : false,
        hasSelection: hasSelection && !!selection,
        checked: hasSelection && selection && selection.has(row),
        checkboxDisabled: isCheckboxDisabled,
        select: select,
        deselect: deselect,
        disabled: disabled,
        massOperation: _this.massOperation
      }, rest));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "isRowVisible", function (rowIndex) {
      var _this$state = _this.state,
          fromIndex = _this$state.fromIndex,
          toIndex = _this$state.toIndex;
      var fullHeight = _this.props.fullHeight; // For non-optimized tables, rows allways visible.

      if (!fullHeight) {
        return true;
      }

      return fromIndex <= rowIndex && rowIndex <= toIndex;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleScroll", function () {
      // Not optimize for tables without fullHeight property
      if (!_this.props.fullHeight) {
        return;
      }

      var rowHeight = _this.props.rowHeight;
      var scrollTop = _this.element.scrollTop;
      var fromIndex = Math.floor(scrollTop / rowHeight);
      var toIndex = Math.ceil((scrollTop + _this.height + 1) / rowHeight);

      if (_this.state.fromIndex !== fromIndex || _this.state.toIndex !== toIndex) {
        _this.setState({
          fromIndex: fromIndex,
          toIndex: toIndex
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateHeight);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateHeight);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref3) {
      var rows = _ref3.rows;

      if (this.props.rows && rows && this.props.rows.length !== rows.length) {
        this.forceUpdate(this.updateHeight);
      }
    }
  }, {
    key: "getEmptyMessage",
    value: function getEmptyMessage() {
      var emptyMessage = this.props.emptyMessage;

      if (!emptyMessage) {
        return (0, _config.__)('No rows found');
      }

      if (emptyMessage instanceof Function) {
        return emptyMessage();
      }

      return emptyMessage;
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var rows = this.props.rows;

      if (!rows || rows.length === 0) {
        return _react.default.createElement(_Error.default, {
          title: this.getEmptyMessage()
        });
      }

      return _react.default.createElement("div", {
        className: "table-content",
        ref: this.handleRef
      }, rows.map(this.renderRow));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props4 = this.props,
          selection = _this$props4.selection,
          selectionBar = _this$props4.selectionBar;

      if (!selectionBar || !selection) {
        return this.renderRows();
      }

      return _react.default.createElement(_tableSelection.default, {
        selection: selection
      }, this.renderRows());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          columns = _this$props5.columns,
          title = _this$props5.title,
          fullHeight = _this$props5.fullHeight,
          className = _this$props5.className,
          rows = _this$props5.rows;
      return _react.default.createElement("div", {
        onScroll: this.handleScroll,
        className: (0, _classnames.default)('table', className, {
          'table--fullHeight': fullHeight
        })
      }, rows && rows.length > 0 && _react.default.createElement(_tableHeader.default, {
        isSelectStub: this.isSelectStub,
        columns: columns
      }), title && rows && rows.length > 0 && _react.default.createElement("h3", {
        className: "table-title"
      }, title), this.renderContent());
    }
  }, {
    key: "isSelectStub",
    get: function get() {
      var _this$props6 = this.props,
          selection = _this$props6.selection,
          selectionBar = _this$props6.selectionBar;
      return selectionBar && selection;
    }
  }]);
  return Table;
}(_react.Component);

exports.default = Table;
(0, _defineProperty2.default)(Table, "defaultProps", {
  selectionBar: true,
  hasSelection: true,
  rowHeight: 45 // .table-row height form styles

});
Table.propTypes = process.env.NODE_ENV !== "production" ? {
  onRowClick: _propTypes.default.func,
  className: _propTypes.default.string,
  select: _propTypes.default.func,
  deselect: _propTypes.default.func,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    fixed: _propTypes.default.bool,
    width: _propTypes.default.number,
    maxWidth: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    render: _propTypes.default.func,
    component: _propTypes.default.elementType
  })),
  active: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),
  title: _propTypes.default.node,
  emptyMessage: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  rows: _propTypes.default.arrayOf(_propTypes.default.object),
  selection: _propTypes.default.instanceOf(Object),
  hasSelection: _propTypes.default.bool,
  fullHeight: _propTypes.default.bool,
  rowHeight: _propTypes.default.number,
  selectionBar: _propTypes.default.bool,
  disabledRowsIds: _propTypes.default.arrayOf(_propTypes.default.number)
} : {};